<template>
  <div class="content" :class="{ 'content-cbr': isColorBlockRun }">
    <div v-if="isColorBlockRun" class="cbr-board">
      <div class="cbr-rail" aria-hidden="true">
        <i class="cbr-cell cbr-cell-red"></i>
        <i class="cbr-cell cbr-cell-orange"></i>
        <i class="cbr-cell cbr-cell-gold"></i>
        <i class="cbr-cell cbr-cell-lime"></i>
        <i class="cbr-cell cbr-cell-sky"></i>
        <i class="cbr-cell cbr-cell-violet"></i>
      </div>
      <p class="cbr-copy">
        <span><em class="cbr-verb cbr-verb-slide">Slide</em> colorful blocks,</span>
        <span><em class="cbr-verb cbr-verb-match">match</em> them to exits</span>
        <span>and <em class="cbr-verb cbr-verb-clear">clear</em> the board!</span>
      </p>
    </div>
    <template v-else>
      <img v-show="$i18n.locale==='zh'" src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title.png"  class='img-title'>
      <img v-show="$i18n.locale==='en'" :src="home_title_en"  class='img-title-en'>
    </template>
    <el-row v-if="$i18n.locale==='zh'" style="margin-top:3vw">
      <el-col :lg="24">
        <div class='home_content'>
          <div class='home_title'>
            <img src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_icon.png"  class='home-title-icon'>
            <p>{{$t('home.bole_we')}}</p>
          </div>
          <el-carousel :interval="1500" type="card" :width="clientHeight" :autoplay="true" class="carou-height hidden-sm-and-down">
            <el-carousel-item v-for="item in bole_images" :key="item.name" :style="item.style">
              <div class="photo-title"><span class="photo-span">2019·年会</span></div>
            </el-carousel-item>
          </el-carousel>
          <el-carousel :interval="1500" type="card" :height="clientHeight2" :autoplay="true" class="carou-height hidden-md-and-up">
            <el-carousel-item v-for="item in bole_images" :key="item.name" :style="item.style">
              <div class="photo-title"><span class="photo-span">2019·年会</span></div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>

      <el-col :lg="24">
        <div class='home_content'>
          <div class='home_title'>
            <img src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_icon.png"  class='home-title-icon'>
            <p>{{$t('home.bole_we')}}</p>
          </div>
          <div class="video_content">
            <div class="video">
              <video v-if="is_mobile_video" src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/bole_video_v3.mp4"  preload="none"
                     controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_1.jpg"> </video>
              <video v-else src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/bole_video_mobile.mp4"  preload="none"
                     controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_1.jpg"> </video>
            </div>
          </div>
        </div>
      </el-col>

    </el-row>
    <el-row v-else-if="!isColorBlockRun" class="content-en-mobile">
      <el-col :lg="24">
        <div class='home_content'>
<!--          <div class="video_content">-->
<!--            <div class="video">-->
<!--              <video src="https://d105xpbtjj9cjp.cloudfront.net/officialweb/videos/home_bole_mobile.mp4"  preload="none"-->
<!--                     controls width="100%" poster="https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/video_3.jpg"> </video>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </el-col>
    </el-row>
  </div>

</template>

<script>
  import { isColorBlockRun as checkColorBlockRun } from "../utils/logo";

  export default {

    data() {
      return {
        all_news: [],
        clientHeight: `${document.documentElement.clientWidth * (4016 / 6016)}px`,
        clientHeight2: `${document.documentElement.clientWidth * (545 / 1920)}px`,

        bole_images: [
          {
            name: 'phpto1',
            style: {
              backgroundImage: `url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/photo_1.jpg')`,
              backgroundSize: '100% ',
              'background-repeat': 'no-repeat',
              backgroundColor: '#0a0726',
            },
          },
          {
            name: 'phpto2',
            style: {
              backgroundImage: `url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/photo_2.jpg')`,
              backgroundSize: '100% ',
              'background-repeat': 'no-repeat',
              backgroundColor: '#0a0726',
            },
          },
           {
            name: 'phpto3',
            style: {
              backgroundImage: `url('https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/photo_3.jpg')`,
              backgroundSize: '100% ',
              'background-repeat': 'no-repeat',
              backgroundColor: '#0a0726',

            },
          },
        ]
      };
    },

    mounted() {
      const that = this;
      window.onresize = function temp() {
        that.clientWidth = `${document.documentElement.clientHeight}px`;
      };
    },
    methods: {
      // test() {
      //   const jsonUrl = './api/upload_emails';
      //   this.axios.get(jsonUrl)
      //     .then((res) => {
      //       console.log(res)
      //     });
      // }
    },
    computed: {
      //是否使用移动端视频
      is_mobile_video() {
        return document.documentElement.clientWidth > 992;
      },
      home_title_en() {
        return document.documentElement.clientWidth > 992 ? 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_en.png' : 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/home_title_en_mobile.png';
      },
      isColorBlockRun() {
        return checkColorBlockRun();
      },
    },
  };
</script>

<style lang='less'>
  /*@import 'element-ui/lib/theme-chalk/display.css';*/
  @import url('../assets/style/common.less');
  @import url('../assets/style/colors.less');
  .content{
    width: 100%;
    margin: 0 auto;
    padding-top: 3%;
  }
  .content-cbr {
    padding-top: 0;
  }
  .cbr-board {
    position: relative;
    overflow: hidden;
    padding: 3.4vw 8vw 3.8vw;
    background:
    radial-gradient(circle at 12% 18%, rgba(255, 214, 102, 0.18), #d6d5fb 34%), 
    radial-gradient(circle at 88% 80%, rgba(86, 196, 255, 0.16), transparent 32%),
     #e6e5f0;
    .cbr-rail {
      display: flex;
      justify-content: center;
      gap: 0.7vw;
      margin-bottom: 2.2vw;
    }
    .cbr-cell {
      display: block;
      width: 2.1vw;
      height: 2.1vw;
      border-radius: 0.42vw;
      box-shadow: 0 0.22vw 0 rgba(42, 28, 8, 0.18);
    }
    .cbr-cell-red { background: #ff5b6b; }
    .cbr-cell-orange { background: #ff8a3c; }
    .cbr-cell-gold { background: #ffd24a; }
    .cbr-cell-lime { background: #7adf5a; }
    .cbr-cell-sky { background: #4ec8ff; }
    .cbr-cell-violet { background: #9b7dff; }
    .cbr-copy {
      margin: 0;
      color: #2c2416;
      span {
        display: block;
        font-size: 2.35vw;
        font-weight: 800;
        letter-spacing: -0.02em;
        line-height: 1.55;
      }
    }
    .cbr-verb {
      display: inline-block;
      font-style: normal;
      font-weight: 800;
      color: #fffef8;
      line-height: 1;
      padding: 0.18em 0.42em 0.22em;
      margin: 0 0.08em;
      border-radius: 0.32em;
      transform: translateY(-0.04em);
      box-shadow: 0 0.12em 0 rgba(42, 28, 8, 0.2);
    }
    .cbr-verb-slide { background: #ff5b6b; }
    .cbr-verb-match { background: #f0b122; }
    .cbr-verb-clear { background: #2db56a; }
  }
  .content-en-mobile {
    display: none;
  }
  .img-title {
    height: 4.5vw;
    margin-bottom:0.5vw
  }
  .img-title-en {
    height: 7.5vw;
    margin-bottom:0.5vw
  }
  .home-title-icon {
    height: 4.5vw;
  }
  .photo-title {
    position: absolute;
    width: 100%;
    bottom: 0;
    background: @lanmu;
    height: 45px;
    font-size: 18px;
    line-height: 43px;
    color: #f3c258;
    border-bottom: 4px solid #f3c258;
    span.photo-span {
      border-bottom: 1px solid;
    }
  }
  .carou-height{
    overflow: hidden;
  }
  @media screen and (max-width: 992px) {
    .content-en-mobile {
      display: block;
      margin: 5vw 0 10vw 0;
    }
    .img-title {
      height: 5.5vw;
      margin-bottom:0.5vw;
    }
    //.img-title-en {
    //  height: 11.5vw;
    //  margin-top: 31vw;
    //  margin-bottom: 14.5vw;
    //}
    .img-title-en {
      height: 11.5vw;
      margin-top: 6vw;
      margin-bottom: -9.5vw;
    }
    .cbr-board {
      padding: 7vw 6vw 8vw;
      .cbr-rail {
        gap: 1.6vw;
        margin-bottom: 5vw;
      }
      .cbr-cell {
        width: 4.6vw;
        height: 4.6vw;
        border-radius: 1vw;
      }
      .cbr-copy span {
        font-size: 5vw;
        line-height: 1.6;
      }
    }
    .home-title-icon {
      height: 6.5vw;
    }
    .photo-title {
      height: 32px;
      font-size: 14px;
      line-height: 30px;
      color: #f3c258;
      border-bottom: 3px solid #f3c258;
      span.photo-span {
        border-bottom: 1px solid;
      }
    }
  }





  //给轮播图选项页增加固定高度，避免抖动
  .el-carousel__indicators--outside {
      height: 4vw;
  }
  .news {
    list-style-type: None;

    .image {
      width: 100%;
      display: block;
    }
    a {
      text-decoration: none;
    }
    .content {
      width: 100%;
      height: 100px;
      background-size: cover;
    }
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>




// WEBPACK FOOTER //
// src/components/Content.vue